<template>
  <div class="address-container">
    <Cascader
      ref="cascader"
      :query="queryApi"
      :multiple="multiple"
      :style="{ width }"
      v-model="area"
      placeholder="所在地址"
      :httpMethod="httpMethod"
    />
  </div>
</template>

<script>
import Cascader from '@/components/CommonForm/Cascader'
export default {
  props: {
    value: {
      type: null,
      default: () => []
    },
    width: {
      type: String,
      default: '200px'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    query: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get'
    }
  },
  components: {
    Cascader
  },
  watch: {
    value() {
      this.area = this.value
    },
    area: {
      deep: true,
      handler: function(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      area: this.value,
      queryApi: this.query
    }
  },
  created() {
    if (!this.query) {
      this.queryApi = this.$api.common.all_area_select
    }
  },
  computed: {
    computedArea() {
      let str = ''
      if (Array.isArray(this.area)) {
        str = this.area.join('/')
      }
      return str
    }
  },
  methods: {
    setArea(val) {
      this.$nextTick(() => {
        this.area = val.slice(0).filter(Boolean)
      })
    },
    clearArea() {
      this.$nextTick(() => {
        this.area = []
        console.log('this.$refs.cascader', this.$refs.cascader.$refs.elCascader.$refs.panel)
        this.$refs.cascader.clear()
      })
    }
  }
}
</script>
<style lang="scss">
.address-container {
  position: relative;
  display: inline-block;
  .hack-span {
    pointer-events: none;
    position: absolute;
    left: 123px;
    width: 153px;
    overflow: hidden;
    white-space: nowrap;
    line-height: 18px;
    font-size: 14px;
    top: 50%;
    background: #fff;
    z-index: 2;
    transform: translateY(-50%);
  }
  .el-input {
    width: 100%;
  }
}
.el-popper.el-cascader__dropdown {
  .el-cascader-node__postfix {
    top: 10px; // 兼容ie箭头位置不正确
  }
}
</style>
